const getUrlState = (url) => {
    if (!url)
        return { state: 'clickable', formattedUrl: undefined };
    const httpRegex = /^(https?:\/\/(?:[\w-]+\.)+[a-z]{2,})(?:\/|$)/;
    const specialProtocolsPattern = /^(mailto:|tel:)/i;
    if (specialProtocolsPattern.test(url)) {
        return { state: 'contact', formattedUrl: url };
    }
    if (!httpRegex.test(url)) {
        const formattedUrl = url.startsWith('/') ? url : `/${url}`;
        return { state: 'internal', formattedUrl };
    }
    if (url.includes('hellodarwin.com')) {
        if (url.includes(`${process.env.CLIENT_APP_URL}`) ||
            url.includes('partner.hellodarwin.com')) {
            return { state: 'app', formattedUrl: url };
        }
        const internalPath = url.replace('https://hellodarwin.com', '');
        const formattedUrl = internalPath.startsWith('/')
            ? internalPath
            : `/${internalPath}`;
        return { state: 'internal', formattedUrl };
    }
    return { state: 'external', formattedUrl: url };
};
export default getUrlState;
